<template>
    <div class="notification">
        <p class="bg-succes-400 text-succes-500 mt-5 mb-6 flex px-6 py-3">
            <CheckCircleIcon class="mr-2.5 size-6 stroke-2" />
            <slot />
        </p>
    </div>
</template>

<script setup lang="ts">
    import { CheckCircleIcon } from '@heroicons/vue/24/outline';
</script>
